import { useEffect, useState } from 'react';
import { Currency } from '../types/api.types';
import { getExchangeRates, ExchangeRates } from '../utils/exchangeRates';

const DEFAULT_RATES: ExchangeRates = {
    USD: 1,
    INR: 96.82,
    CAD: 1.37,
};

export function useExchangeRates() {
    const [rates, setRates] = useState<ExchangeRates>(DEFAULT_RATES);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        getExchangeRates()
            .then(setRates)
            .catch((err) => {
                console.error('Error fetching exchange rates:', err);
                setError(err.message);
            })
            .finally(() => setLoading(false));
    }, []);

    const convertCurrency = (amount: number, fromCurrency: Currency, toCurrency: Currency): number => {
        if (fromCurrency === toCurrency) return amount;
        return (amount / rates[fromCurrency]) * rates[toCurrency];
    };

    return { rates, convertCurrency, loading, error };
}
